import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  text-align: left;
  padding: 20px;
  overflow: auto;
  @media only screen and (max-width: 500px) {
    padding-top: 60px;
  }
`;

export const Title = styled.h1`
  margin: 0;
  text-align: left;
  color: #0083ff;
  font-size: 18px;
`;

export const Button = styled.button`
  background: ${props => (props.submit ? '#0083ff' : '#FF8800')};
  color: white;
  cursor: pointer;
  font-size: 14px;
  border-radius: 4px;
  border: none;
  height: 30px;
  padding: 0 20px;
`;

export const Header = styled.div`
  flex: 1;
  display: flex;
  padding: 10px;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #d3d3d3;
  margin-bottom: 20px;
  border-radius: 4px;
`;
